<template>
    <el-dialog
            title="Kontrol Ekle"
            :visible.sync="visible"
            width="100%"
            custom-class="musteri-kontrol-form-dialog"
            :close-on-click-modal="false"
            :close-on-press-escape="false">

        <br>

        <el-form ref="form" :model="form" :rules="rules" label-position="top">
            <el-form-item prop="tahsilat_yapildi" label="Tahsilat Yapıldı mı?">
                <el-radio-group v-model="form.tahsilat_yapildi">
                    <el-radio-button label="1" name="1">
                        <i class="el-icon-circle-check"/> Yapıldı
                    </el-radio-button>
                    <el-radio-button label="0" name="0">
                        <i class="el-icon-circle-close"/> Yapılmadı
                    </el-radio-button>
                </el-radio-group>
            </el-form-item>
            <el-form-item
                v-if="form.tahsilat_yapildi === '1'"
                prop="tahsilat_tutari"
                label="Tahsilat Tutarı">
                <el-input
                    v-model="form.tahsilat_tutari"
                    style="width: 100%"
                    placeholder="Tahsilat Tutarı"
                    type="number">
                    <span slot="prepend">₺</span>
                </el-input>
            </el-form-item>
            <el-divider/>
            <el-form-item prop="dolum_yapildi" label="Dolum Yapıldı mı?">
                <el-radio-group v-model="form.dolum_yapildi">
                    <el-radio-button label="1" name="11">
                        <i class="el-icon-circle-check"/> Yapıldı
                    </el-radio-button>
                    <el-radio-button label="0" name="00">
                        <i class="el-icon-circle-close"/> Yapılmadı
                    </el-radio-button>
                </el-radio-group>
            </el-form-item>
            <el-form-item
                v-if="form.dolum_yapildi === '1'"
                prop="dolum_ml"
                label="Dolum mililitre">
                <el-input
                    v-model="form.dolum_ml"
                    style="width: 100%"
                    placeholder="Dolum mililitre"
                    type="number">
                    <span slot="prepend">ml</span>
                </el-input>
            </el-form-item>

            <el-divider/>

            <el-form-item prop="not">
                <el-input
                    type="textarea"
                    :autosize="{ minRows: 2, maxRows: 4}"
                    placeholder="Not girin"
                    v-model="form.not"></el-input>
            </el-form-item>

        </el-form>

        <br>

        <el-row class="mar" type="flex" justify="end">
            <el-button type="danger" @click="close">Iptal</el-button>
            <el-button type="success" icon="el-icon-check" @click="save">Kaydet</el-button>
        </el-row>
    </el-dialog>
</template>

<script>
    import moment from "moment";

    export default {
        name: 'musteri-kontrol-form',
        model: {
            props: 'value',
            event: 'change',
        },
        props: {
            value: { type: Boolean, required: true },
            musteriId: { type: [Number, String], required: true },
            kontrolZamani: { type: Object, required: true },
        },
        data() {
            return {
                visible: false,
                form: {
                    musteri_id: null,
                    yil: null,
                    ay: null,
                    not: null,
                    kontrol_zamani: null,
                    tahsilat_yapildi: '1',
                    tahsilat_tutari: null,
                    dolum_yapildi: '1',
                    dolum_ml: null,
                },
                rules: {
                    not: [{required: true, message: 'Not gerekli', trigger: 'change'}],
                    tahsilat_yapildi: [{required: true, message: 'Tahsilat yapıldı gerekli', trigger: 'change'}],
                    dolum_yapildi: [{required: true, message: 'Dolum yapıldı gerekli', trigger: 'change'}],
                },
            };
        },
        methods: {
            close() {
                this.visible = false;
            },
            save() {
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        this.submit();
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            submit() {
                const form = Object.assign({}, this.form);
                form.ay = this.kontrolZamani.get('month');
                form.yil = this.kontrolZamani.get('year');
                form.kontrol_zamani = moment().format('YYYY-MM-DD HH:mm:ss');
                form.musteri_id = this.musteriId;

                if (form.tahsilat_yapildi === '1' && !form.tahsilat_tutari) {
                    this.$message.warning('Lütfen tahsilat tutarı giriniz!');
                    return;
                }

                if (form.tahsilat_yapildi === '0') {
                    delete form.tahsilat_tutari;
                }

                this.loading = true;
                this.$requests
                    .MusteriKontrol.createMusteriKontrol(form)
                    .then(() => {
                        this.$refs.form.resetFields();
                        this.close();
                    })
                    .catch((e) => {
                        console.error('error', e);
                    })
                    .then(() => {
                        this.loading = false;
                    });
            },
        },
        mounted() {
            this.visible = this.value;
        },
        watch: {
            value() {
                this.visible = this.value;
            },
            visible() {
                if (this.value !== this.visible) {
                    this.$emit('change', this.visible);
                }

                //
                if (!this.visible) {
                    this.$refs.form.resetFields();
                    this.$emit('done');
                }
            },
        },
    };
</script>

<style lang="scss" scoped>

    .el-input  {
        ::v-deep .el-input__inner {
            width: 100%;
        }
    }
    .mar {
        margin: 10px 20px;
    }

</style>
